module.exports = __webpack_public_path__ + "static/media/New SVG-1.19b97de0.png";